var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NG_VALIDATORS } from '@angular/forms';
import { Directive, forwardRef } from '@angular/core';
var NotEmptyValidatorDirective = /** @class */ (function () {
    function NotEmptyValidatorDirective() {
        this.validator = this.validateEmptyFactory();
    }
    NotEmptyValidatorDirective_1 = NotEmptyValidatorDirective;
    NotEmptyValidatorDirective.prototype.validateEmptyFactory = function () {
        return function (c) {
            if (c.value == null) {
                return { required: true };
            }
            var invalid = c.value.match(/^\s+$/) || c.value.match(/^[ ]+$/) || c.value.match(/^[ ]*$/) || c.value.match(/^\s*$/);
            if (invalid) {
                return { required: true };
            }
            return undefined;
        };
    };
    NotEmptyValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var NotEmptyValidatorDirective_1;
    NotEmptyValidatorDirective = NotEmptyValidatorDirective_1 = __decorate([
        Directive({
            selector: '[not-empty][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return NotEmptyValidatorDirective_1; }), multi: true }
            ]
        })
    ], NotEmptyValidatorDirective);
    return NotEmptyValidatorDirective;
}());
export { NotEmptyValidatorDirective };
